import { useState, useEffect } from 'react';
import { fetchModuleWithDetails } from '../../Services/CourseListService';
import { toast } from 'react-toastify';

const useModuleDetails = (moduleId) => {
  const [module, setModule] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getModuleDetails = async () => {
      if (!moduleId) {
        setError('Module ID is required');
        toast.error("Module Id is required");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        console.log('Fetching module details for ID:', moduleId);
        
        const moduleData = await fetchModuleWithDetails(moduleId);
        console.log('Module details fetched:', moduleData);
        
        setModule(moduleData);
      } catch (err) {
        console.error('Error in useModuleDetails hook:', err);
        setError(err?.response?.data?.message || err.message || 'Failed to fetch module details');
        toast.err(err?.response?.data?.message || err);
      } finally {
        setLoading(false);
      }
    };

    getModuleDetails();
  }, [moduleId]);

  return { module, loading, error };
};

export default useModuleDetails;